import React from 'react';
import cx from 'classnames';
import withStyles from 'isomorphic-style-loader/lib/withStyles';

import LogoutIcon from './LogoutIcon';
import s from './LogoutOverlay.css';

class LoginTab extends React.Component {
  render() {
    return (
      <div className={s.overlay}>
        <div>
          <LogoutIcon />
          <div className={s.loading}>
            <div className={cx(s.dot, s.d1)} />
            <div className={cx(s.dot, s.d2)} />
            <div className={cx(s.dot, s.d3)} />
          </div>
        </div>
        <p>Logging out. Hang in there.</p>
      </div>
    );
  }
}

export default withStyles(s)(LoginTab);



// WEBPACK FOOTER //
// ./src/components/LogoutOverlay/LogoutOverlay.js